// extracted by mini-css-extract-plugin
export default {"queueTableTitleWrapper":"ActivityPage_queueTableTitleWrapper__F3GYD","historyTableTitleWrapper":"ActivityPage_historyTableTitleWrapper__Ls451"};